import { useState } from 'react';
import { articlesService } from '../../../apiServices/articles.service';

export const useDeleteArticle = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteArticle = async (id: number) => {
    setLoading(true);
    setError(null);
    try {
      await articlesService.deleteById(id);
    } catch (err: any) {
      setError(err?.message || 'Error al eliminar el artículo');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => setError(null);

  return {
    deleteArticle,
    loading,
    error,
    clearError,
  };
};
